import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { ProductImage } from '../../components/aurora';

import { productTypes } from '../../types/products';

const PdpThumbnails = ({ products, currProductCode, styleNum, handleThumbnailClick }) => (
  <ul className='pdp__thumbnails mt4-sm mb7-sm prl2-sm prl0-md' data-testid='pdp_thumbnails'>
    {products.map((product, idx) => (
      <li
        className={classnames('pdp__image_thumb-wrap', {
          isActive: currProductCode === product.productCode
        })}
        data-desc={`pdp__image_thumb-${idx}`}
        key={`${styleNum}-${product.color}-image`}
      >
        <button type='button' onClick={() => handleThumbnailClick(product.productCode)}>
          <div
            className={classnames('pdp__image_thumb pt1-sm', {
              isUnavailable:
                product.availabilityStatus === 'Available Soon' || product.availabilityStatus === 'Out of Stock'
            })}
          >
            <ProductImage alt={product.productCode} productCode={product.productCode} />
          </div>
        </button>
      </li>
    ))}
  </ul>
);

PdpThumbnails.propTypes = {
  currProductCode: PropTypes.string.isRequired,
  handleThumbnailClick: PropTypes.func.isRequired,
  products: PropTypes.arrayOf(productTypes).isRequired,
  styleNum: PropTypes.string.isRequired
};

export default PdpThumbnails;
